import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { I18nProvider } from "./lib/i18n";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Loader2 } from "lucide-react";

import Home from "./pages/Home";
import BookingWizard from "./pages/BookingWizard";
import FAQ from "./pages/FAQ";
import Legal from "./pages/Legal";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Account from "./pages/Account";
import PartnerDashboard from "./pages/partner/PartnerDashboard";
import PartnerOrder from "./pages/partner/PartnerOrder";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminPartners from "./pages/admin/AdminPartners";
import AdminServices from "./pages/admin/AdminServices";
import AdminReviews from "./pages/admin/AdminReviews";
import AdminFAQ from "./pages/admin/AdminFAQ";

function Protected({ roles, children }) {
  const { user, checking } = useAuth();
  if (checking || user === null) {
    return <div className="min-h-screen flex items-center justify-center bg-slate-50"><Loader2 className="animate-spin text-slate-400" /></div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    const dest = user.role === "admin" ? "/admin" : user.role === "partner" ? "/partner" : "/account";
    return <Navigate to={dest} replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/boeken" element={<BookingWizard />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/privacy" element={<Legal type="privacy" />} />
              <Route path="/cookies" element={<Legal type="cookies" />} />
              <Route path="/voorwaarden" element={<Legal type="voorwaarden" />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/account" element={<Protected roles={["customer"]}><Account /></Protected>} />
              <Route path="/partner" element={<Protected roles={["partner"]}><PartnerDashboard /></Protected>} />
              <Route path="/partner/opdracht/:id" element={<Protected roles={["partner"]}><PartnerOrder /></Protected>} />
              <Route path="/admin" element={<Protected roles={["admin"]}><AdminDashboard /></Protected>} />
              <Route path="/admin/opdrachten" element={<Protected roles={["admin"]}><AdminOrders /></Protected>} />
              <Route path="/admin/partners" element={<Protected roles={["admin"]}><AdminPartners /></Protected>} />
              <Route path="/admin/diensten" element={<Protected roles={["admin"]}><AdminServices /></Protected>} />
              <Route path="/admin/reviews" element={<Protected roles={["admin"]}><AdminReviews /></Protected>} />
              <Route path="/admin/faq" element={<Protected roles={["admin"]}><AdminFAQ /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
